let configPromise;
const configured = new Set();
const sent = new Set();

function publicConfiguration() {
  if (!configPromise) {
    configPromise = window.fetch('/booking-tracking.json', { cache: 'no-cache' })
      .then(response => response.ok ? response.json() : null)
      .catch(() => null);
  }
  return configPromise;
}

async function companyConfiguration(companyId) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  const id = Number(companyId);
  if (!Number.isInteger(id) || id < 1) return null;
  const config = (await publicConfiguration())?.companies?.[id];
  if (!config || config.industry !== 'transportation' || !Array.isArray(config.hosts) || !config.hosts.includes(window.location.hostname)) return null;
  const ads = config.google_ads;
  return /^AW-\d+$/.test(ads?.conversion_id || '') && /^[A-Za-z0-9_-]+$/.test(ads?.conversion_label || '') ? ads : null;
}

export async function initializeBookingConversionTracking(companyId) {
  const ads = await companyConfiguration(companyId);
  if (!ads) return null;
  if (!configured.has(ads.conversion_id)) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
    }
    if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ads.conversion_id);
      script.dataset.traveldeskBookingTag = ads.conversion_id;
      document.head.appendChild(script);
    }
    window.gtag('config', ads.conversion_id, { send_page_view: false });
    configured.add(ads.conversion_id);
  }
  return ads;
}

export async function trackConfirmedBookingConversion({ companyId, response }) {
  const reservation = response?.data?.booking_id ? response.data : response?.booking_id ? response : null;
  if (!reservation || Number(reservation.company_id) !== Number(companyId) || ![1, 5].includes(Number(reservation.aptRes_status))) return { sent: false, reason: 'not_confirmed' };
  const bookingId = String(reservation.booking_id).trim();
  const value = Number(reservation.aptRes_total);
  const currency = String(reservation.aptRes_currency || '').toUpperCase();
  if (!bookingId || bookingId.length > 191 || reservation.aptRes_total === null || reservation.aptRes_total === undefined || !Number.isFinite(value) || value < 0 || !/^[A-Z]{3}$/.test(currency)) return { sent: false, reason: 'invalid_reservation_value' };
  const id = Number(companyId) + ':' + bookingId;
  const key = 'traveldesk_google_ads_booking_' + id;
  if (sent.has(id)) return { sent: false, reason: 'duplicate' };
  try { if (window.sessionStorage.getItem(key) === '1') return { sent: false, reason: 'duplicate' }; } catch { /* Google also deduplicates by transaction ID. */ }
  const ads = await initializeBookingConversionTracking(companyId);
  if (!ads) return { sent: false, reason: 'not_configured' };
  if (sent.has(id)) return { sent: false, reason: 'duplicate' };
  window.gtag('event', 'conversion', { send_to: ads.conversion_id + '/' + ads.conversion_label, transaction_id: id, value, currency });
  sent.add(id);
  try { window.sessionStorage.setItem(key, '1'); } catch { /* Keep the memory marker. */ }
  return { sent: true, transaction_id: id };
}
